import { render, staticRenderFns } from "./PostPublishRequest.vue?vue&type=template&id=5b181ea4"
import script from "./PostPublishRequest.vue?vue&type=script&lang=js"
export * from "./PostPublishRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports